import { render, staticRenderFns } from "./CaptainPayments.vue?vue&type=template&id=367d0da3&scoped=true"
import script from "./CaptainPayments.vue?vue&type=script&lang=js"
export * from "./CaptainPayments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "367d0da3",
  null
  
)

export default component.exports